import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
  vectorEffect?: string | null;
} & Omit<React.SVGProps<SVGSVGElement>, "vectorEffect">;

export const MoveIcon: React.FC<Props> = ({
  color,
  vectorEffect,
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.1 18.1"
      height={getDefaultHeight(svgProps, 18.1)}
      {...svgProps}
    >
      <path
        fill="none"
        stroke={color ?? "currentColor"}
        strokeWidth="1"
        strokeLinecap="round"
        vectorEffect={
          vectorEffect === null
            ? undefined
            : (vectorEffect ?? "non-scaling-stroke")
        }
        d="m7.1 3.1 2-2 2 2M11.1 15.1l-2 2-2-2M3.1 11.1l-2-2 2-2M15.1 7.1l2 2-2 2M9.1 2.1v13.8M2.2 9H16"
      />
    </SVG>
  );
};
